import * as THREE from "three";
import { camera } from "../js/camera";
import { renderer } from "../js/renderer";
import { createSky } from "../js/sky";
import { GamePad } from "./gamepad3.js";
import { GLTFLoader } from "./libs/threejs/GLTFLoader.js";
//import Stats from "./libs/threejs/stats.module.js";
import TouchControls from "./TouchControls.js";

let mixer = null;
let clock = new THREE.Clock();

const isMobile =
  typeof navigator !== "undefined" &&
  (navigator.userAgent.match(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  ) ||
    navigator.maxTouchPoints > 1);

let scene, controls, stats;
let signalObject,
  dbObject,
  dblogoContainer,
  ufoObject,
  wheelObject,
  carObject,
  heliObject,
  fanObject,
  balloonObject,
  ufoContainer,
  carContainer,
  balloonContainer,
  heliContainer,
  intersected;

let width;
let height;
let aspect;
let container = document.getElementById("container3d");

function loadGLTFModel(path, file) {
  return new Promise((resolve, reject) => {
    const loader = new GLTFLoader().setPath(path);
    loader.load(file, resolve, undefined, reject);
  });
}

//create wall and box
function createBlockingBox(position, size, visible, name) {
  let geometry = new THREE.BoxGeometry(size.x, size.y, size.z);
  let material = new THREE.MeshBasicMaterial({ visible: visible });
  let box = new THREE.Mesh(geometry, material);
  box.position.copy(position);
  box.name = name;
  scene.add(box);
  return box;
}
//

//sky
const sky = createSky();
//

//jump
let isJumping = false;
let jumpSpeed = 1.5;
let jumpHeight = 30;
let initialY = 20;
let jumpDirection = 1;

function jump() {
  if (!isJumping) {
    isJumping = true;
    jumpDirection = 1;

    if (initialY === null) {
      initialY = control.fpsBody.position.y + 20;
    }
  }
}

startScene(container);

function startScene(container) {
  width = window.innerWidth;
  height = window.innerHeight;
  aspect = width / height;
  scene = new THREE.Scene();
  scene.add(sky);

  const cityDir = isMobile ? "model/mobile/" : "model/";
  const cityModel = isMobile ? "/city-mobile.gltf" : "city.gltf";

  const resources = [
    loadGLTFModel(cityDir, cityModel).then((gltf) => {
      const cityObject = gltf.scene;
      cityObject.scale.set(10, 10, 10);
      cityObject.position.set(0, 0, 0);
      scene.add(cityObject);
    }),
    loadGLTFModel("model/", "ufo.gltf").then((gltf) => {
      ufoObject = gltf.scene;
      ufoObject.scale.set(30, 30, 30);
      ufoObject.position.set(200, 600, -1200);
      scene.add(ufoObject);
    }),
    loadGLTFModel("model/", "car.gltf").then((gltf) => {
      carObject = gltf.scene;
      carObject.scale.set(15, 15, 15);
      carObject.position.set(-40, -2.5, -310);
      scene.add(carObject);
    }),
    loadGLTFModel("model/", "helicopter.gltf").then((gltf) => {
      heliObject = gltf.scene;
      heliObject.scale.set(1200, 1200, 1200);
      heliObject.position.set(400, 180, -210);
      scene.add(heliObject);
    }),
    loadGLTFModel("model/", "fan.gltf").then((gltf) => {
      fanObject = gltf.scene;
      fanObject.scale.set(1200, 1200, 1200);
      fanObject.position.set(400, 211, -230);
      scene.add(fanObject);
    }),
    loadGLTFModel("model/", "baloon.gltf").then((gltf) => {
      balloonObject = gltf.scene;
      balloonObject.scale.set(0.7, 0.7, 0.7);
      balloonObject.position.set(-600, 550, -400);
      scene.add(balloonObject);
    }),
    loadGLTFModel("model/", "wheel.gltf").then((gltf) => {
      wheelObject = gltf.scene;
      wheelObject.scale.set(10, 10, 10);
      wheelObject.position.set(700, 10, -870);
      wheelObject.rotation.set(0, 1, 0);
      scene.add(wheelObject);
      mixer = new THREE.AnimationMixer(wheelObject);
      gltf.animations.forEach((clip) => {
        mixer.clipAction(clip).play();
      });
    }),

    loadGLTFModel("model/", "signal.gltf").then((gltf) => {
      signalObject = gltf.scene;
      signalObject.scale.set(19, 19, 19);
      signalObject.position.set(-35, -30, 140);
      signalObject.rotation.set(0, 3.11, 0);
      scene.add(signalObject);
    }),
    loadGLTFModel("model/", "dblogo.gltf").then((gltf) => {
      dbObject = gltf.scene;
      dbObject.scale.set(2100, 2100, 2100);
      dbObject.position.set(-210, 78, 48);
      dbObject.rotation.set(1.6, 0, 0);
      scene.add(dbObject);
    }),
  ];

  const preloader = document.getElementById("preloader");

  let loaded = 0;

  resources.forEach((promise, index) => {
    promise.then(() => {
      loaded++;
    });
  });

  Promise.all(resources)
    .then(() => {
      preloader.style.display = "none";
      initializeScene();
      render();
    })
    .catch((error) => {
      console.error("Error loading resources:", error);
    });

  /*
  stats = new Stats();
  stats.domElement.style.top = "10px";
  stats.domElement.style.right = "10px";
  document.body.append(stats.domElement);
  */

  window.addEventListener("resize", onWindowResize);
}

function initializeScene() {
  addLights();
  addControls();
}

function addLights() {
  let ambient = new THREE.AmbientLight(0x404040);
  scene.add(ambient);

  let light1 = new THREE.PointLight(0xffffff);
  light1.position.set(0, 2000, 750);
  light1.intensity = 0.45;
  scene.add(light1);

  let light2 = new THREE.PointLight(0xffffff);
  light2.position.set(5, 100, -200);
  light2.intensity = 0.4;
  scene.add(light2);
}

function addControls() {
  let options = {
    delta: 0.75,
    moveSpeed: 2,
    rotationSpeed: 0.004,
    maxPitch: 55,
    hitTest: true,
    hitTestDistance: 30,
  };
  controls = new TouchControls(container.parentNode, camera, options);
  controls.setPosition(-38, 25, 250);
  controls.addToScene(scene);
}

const controller = new GamePad(camera);

function render() {
  requestAnimationFrame(render);
  controls.update();
  controller.update();

  let vector = new THREE.Vector3(controls.mouse.x, controls.mouse.y, 1);
  vector.unproject(camera);

  let raycaster = new THREE.Raycaster(
    controls.fpsBody.position,
    vector.sub(controls.fpsBody.position).normalize()
  );
  let intersects = raycaster
    .intersectObjects(signalObject ? signalObject.children : [])
    .concat(raycaster.intersectObject(dblogoContainer))
    .concat(raycaster.intersectObject(ufoContainer))
    .concat(raycaster.intersectObject(carContainer))
    .concat(raycaster.intersectObject(balloonContainer))
    .concat(raycaster.intersectObject(heliContainer));

  if (intersects.length > 0) {
    if (intersected != intersects[0].object) {
      if (
        intersected &&
        intersected.material &&
        intersected.material.emissive
      ) {
        intersected.material.emissiveIntensity = 0.05;
        intersected.material.emissive.setHex(intersected.currentHex);
      }
      intersected = intersects[0].object;

      if (
        intersected &&
        intersected.material &&
        intersected.material.emissive
      ) {
        intersected.currentHex = intersected.material.emissive.getHex();
        intersected.material.emissiveIntensity = 0.2;
        intersected.material.emissive.setHex(0x00aaff);
      }

      if (intersected.name == "dblogoContainer") {
        dbObject.traverse((child) => {
          if (child.material && child.material.emissive) {
            child.currentHex = child.material.emissive.getHex();
            child.material.emissiveIntensity = 0.1;
            child.material.emissive.setHex(0x00aaff);
          }
        });
      }

      if (intersected.name == "ufoContainer") {
        ufoObject.traverse((child) => {
          if (child.material && child.material.emissive) {
            child.currentHex = child.material.emissive.getHex();
            child.material.emissiveIntensity = 0.1;
            child.material.emissive.setHex(0x00aaff);
          }
        });
      }

      if (intersected.name == "carContainer") {
        carObject.traverse((child) => {
          if (child.material && child.material.emissive) {
            child.currentHex = child.material.emissive.getHex();
            child.material.emissiveIntensity = 0.1;
            child.material.emissive.setHex(0x00aaff);
          }
        });
      }

      if (intersected.name == "balloonContainer") {
        balloonObject.traverse((child) => {
          if (child.material && child.material.emissive) {
            child.currentHex = child.material.emissive.getHex();
            child.material.emissiveIntensity = 0.1;
            child.material.emissive.setHex(0x00aaff);
          }
        });
      }

      if (intersected.name == "heliContainer") {
        heliObject.traverse((child) => {
          if (child.material && child.material.emissive) {
            child.currentHex = child.material.emissive.getHex();
            child.material.emissiveIntensity = 0.1;
            child.material.emissive.setHex(0x00aaff);
          }
        });
      }

      document.body.style.cursor = "pointer";
    }
  } else {
    if (intersected) {
      if (
        intersected &&
        intersected.material &&
        intersected.material.emissive
      ) {
        intersected.material.emissive.setHex(intersected.currentHex);
      }

      dbObject.traverse((child) => {
        if (
          child.material &&
          child.material.emissive &&
          child.currentHex !== undefined
        ) {
          child.material.emissive.setHex(child.currentHex);
        }
      });

      ufoObject.traverse((child) => {
        if (
          child.material &&
          child.material.emissive &&
          child.currentHex !== undefined
        ) {
          child.material.emissive.setHex(child.currentHex);
        }
      });

      carObject.traverse((child) => {
        if (
          child.material &&
          child.material.emissive &&
          child.currentHex !== undefined
        ) {
          child.material.emissive.setHex(child.currentHex);
        }
      });

      balloonObject.traverse((child) => {
        if (
          child.material &&
          child.material.emissive &&
          child.currentHex !== undefined
        ) {
          child.material.emissive.setHex(child.currentHex);
        }
      });

      heliObject.traverse((child) => {
        if (
          child.material &&
          child.material.emissive &&
          child.currentHex !== undefined
        ) {
          child.material.emissive.setHex(child.currentHex);
        }
      });
    }

    intersected = null;
    document.body.style.cursor = "default";
  }

  renderer.render(scene, camera);
}

function onWindowResize() {
  width = window.innerWidth - 50;
  height = window.innerHeight - 80;

  camera.aspect = width / height;
  camera.updateProjectionMatrix();

  /*
  if (isMobile) {
    renderer.setSize(window.innerWidth / 10, window.innerHeight / 10);
  } else {
    renderer.setSize(width, height);
  }
  */

  renderer.setSize(width, height);
}

//wall front
createBlockingBox(
  new THREE.Vector3(0, 0, 310),
  new THREE.Vector3(1500, 100, 100),
  false,
  "wall1"
);

//wall left
createBlockingBox(
  new THREE.Vector3(-450, 0, 310),
  new THREE.Vector3(100, 100, 3000),
  false,
  "wall2"
);

//wall right
createBlockingBox(
  new THREE.Vector3(880, 0, 310),
  new THREE.Vector3(100, 100, 3000),
  false,
  "wall3"
);

//wall retro
createBlockingBox(
  new THREE.Vector3(0, 0, -1100),
  new THREE.Vector3(2000, 100, 100),
  false,
  "wall4"
);
//info
createBlockingBox(
  new THREE.Vector3(-36, 10, 140),
  new THREE.Vector3(20, 50, 1),
  false,
  "wall4"
);

//dblogo container
dblogoContainer = createBlockingBox(
  new THREE.Vector3(-168, 90, 60),
  new THREE.Vector3(70, 20, 10),
  false,
  "dblogoContainer"
);

//ufo container
ufoContainer = createBlockingBox(
  new THREE.Vector3(210, 590, -1180),
  new THREE.Vector3(160, 66, 160),
  false,
  "ufoContainer"
);

//car container
carContainer = createBlockingBox(
  new THREE.Vector3(-40, 9, -310),
  new THREE.Vector3(75, 20, 40),
  false,
  "carContainer"
);

//balloon container
balloonContainer = createBlockingBox(
  new THREE.Vector3(-600, 300, -400),
  new THREE.Vector3(160, 250, 160),
  false,
  "balloonContainer"
);

//heli container
heliContainer = createBlockingBox(
  new THREE.Vector3(400, 220, -200),
  new THREE.Vector3(60, 40, 110),
  false,
  "heliContainer"
);

function optimizeForMobile(scene, camera) {
  if (isMobile) {
    camera.far = 1200;
    camera.updateProjectionMatrix();

    renderer.shadowMap.enabled = false;

    scene.traverse((object) => {
      if (object.isMesh && object.material.map) {
        object.material.map.minFilter = THREE.LinearFilter;
        object.material.map.generateMipmaps = false;
      }
    });
  }
}

optimizeForMobile(scene, camera);

function animate() {
  const deltaTime = clock.getDelta();
  let time = clock.getElapsedTime();

  requestAnimationFrame(animate);

  if (ufoObject) {
    ufoObject.rotation.y += 0.005;
  }

  if (fanObject) {
    fanObject.rotation.y += 0.08;
  }

  if (balloonObject) {
    balloonObject.position.y = 200 + Math.sin(time * 1.5) * 3.5;
  }

  if (heliObject) {
    heliObject.position.y = 200 + Math.sin(time * 1.5) * 3.5;
  }

  if (fanObject) {
    fanObject.position.y = 230 + Math.sin(time * 1.5) * 3.5;
  }

  if (mixer) mixer.update(deltaTime);

  if (isJumping) {
    controls.fpsBody.position.y += jumpSpeed * jumpDirection;

    if (controls.fpsBody.position.y >= initialY + jumpHeight) {
      jumpDirection = -1;
    }
    if (controls.fpsBody.position.y <= initialY) {
      isJumping = false;
      controls.fpsBody.position.y = initialY;
    }
  }
}

window.addEventListener("keydown", (event) => {
  if (event.code === "Space") {
    jump();
  }
});

animate();
